import { Outlet, ScrollRestoration, useLocation } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { AnimatePresence } from 'framer-motion';

export default function RootLayout() {
  const location = useLocation();

  return (
    <div className="min-h-screen flex flex-col overflow-hidden relative">
      <ScrollRestoration />
      <Header />
      <main className="grow relative z-10">
        <AnimatePresence mode="wait">
          <Outlet key={location.pathname} />
        </AnimatePresence>
      </main>
      <Footer />
    </div>
  );
}

